<template>
  <base-page>
    <titlu-pagina Titlu="Setari programator" />

    <el-row class="main-page">

      <el-col class="coloana" :span="16">
        <el-card style='margin:5px 0px 5px 0px'>
          <div slot="header">
            <span>Texte programator</span>

            <el-button @click="save()" style="float: right; padding: 6px 12px; " type="success" plain round
              size="large"> Salveaza </el-button>
            <el-button @click="sterge" style="float: right; padding: 6px 12px; margin: 0 10px;" type="danger" plain
              round size="large"> Sterge </el-button>

          </div>
          <el-form label-position="top" :model="Texte_programator" :inline="false" :rules="rules" label-width="100%"
            ref='my-form' @submit.prevent="save_sms">
            <span class="commands">Pagina #1</span>
            <hr />
            <el-row>
              <el-form-item label='Titlu' prop="TitleProgramator1">
                <el-input v-model="Texte_programator.TitleProgramator1"></el-input>
              </el-form-item>
              <el-form-item label='Descriere' prop="SubtitleProgramator1">
                <el-input v-model="Texte_programator.SubtitleProgramator1"></el-input>
              </el-form-item>
            </el-row>

            <span class="commands">Pagina #2</span>
            <hr />

            <!-- <hr /> -->
            <el-row>
              <el-form-item label='Titlu' prop="TitleProgramator2">
                <el-input v-model="Texte_programator.TitleProgramator2"></el-input>
              </el-form-item>
              <el-form-item label='Descriere' prop="SubtitleProgramator2">
                <el-input v-model="Texte_programator.SubtitleProgramator2"></el-input>
              </el-form-item>
            </el-row>

            <span class="commands">Pagina #3</span>
            <hr />

            <!-- <hr /> -->
            <el-row>
              <el-form-item label='Titlu' prop="TitleProgramator3">
                <el-input v-model="Texte_programator.TitleProgramator3"></el-input>
              </el-form-item>
              <el-form-item label='Descriere' prop="SubtitleProgramator3">
                <el-input v-model="Texte_programator.SubtitleProgramator3"></el-input>
              </el-form-item>
            </el-row>

            <span class="commands">Pagina #4</span>
            <hr />

            <!-- <hr /> -->
            <el-row>
              <el-form-item label='Titlu' prop="TitleProgramator4">
                <el-input v-model="Texte_programator.TitleProgramator4"></el-input>
              </el-form-item>
              <el-form-item label='Descriere' prop="SubtitleProgramator4">
                <el-input v-model="Texte_programator.SubtitleProgramator4"></el-input>
              </el-form-item>
            </el-row>


          </el-form>

        </el-card>
      </el-col>
    </el-row>



  </base-page>
</template>

<script>
import settings from "@/backend/LocalSettings";
import BasePage from "@/pages/Admin/BasePage";
import TitluPagina from "@/widgets/TitluPagina";


export default {
  name: "Setari_programator",
  extends: BasePage,
  components: {
    "base-page": BasePage,
    "titlu-pagina": TitluPagina,
  },
  data() {
    return {
      Texte_programator: {
        TitleProgramator1: "",
        TitleProgramator2: "",
        TitleProgramator3: "",
        SubtitleProgramator1: "",
        SubtitleProgramator2: "",
        SubtitleProgramator3: "",
      },
      rules: {
        TitleProgramator1: [{ required: true, message: 'Campul este obligatoriu' }],
        TitleProgramator2: [{ required: true, message: 'Campul este obligatoriu' }],
        TitleProgramator3: [{ required: true, message: 'Campul este obligatoriu' }],

      }

    };
  },
  methods: {

    async get_info() {
      var response = await this.post("admin/setari/index");
      // console.log(response); a
      this.Texte_programator.TitleProgramator1 = response.Setari.TitleProgramator1;
      this.Texte_programator.TitleProgramator2 = response.Setari.TitleProgramator2;
      this.Texte_programator.TitleProgramator3 = response.Setari.TitleProgramator3;
      this.Texte_programator.SubtitleProgramator1 = response.Setari.SubtitleProgramator1;
      this.Texte_programator.SubtitleProgramator2 = response.Setari.SubtitleProgramator2;
      this.Texte_programator.SubtitleProgramator3 = response.Setari.SubtitleProgramator3;

    },

    sterge: async function () {
      this.Texte_programator.TitleProgramator1 = "";
      this.Texte_programator.TitleProgramator2 = "";
      this.Texte_programator.TitleProgramator3 = "";
      this.Texte_programator.SubtitleProgramator1 = "";
      this.Texte_programator.SubtitleProgramator2 = "";
      this.Texte_programator.SubtitleProgramator3 = "";
    },


    save: async function () {
      this.$refs['my-form'].validate(async (valid) => {
        if (valid) {
          var save_response = await this.post("admin/setari/save_texte", { Setari: this.Texte_programator });
          if (save_response.Raspuns) {
            this.$notify({
              title: 'Succes',
              message: 'Modificarile au fost salvate!',
              type: 'success',
            });
          } else {
            this.$notify({
              title: 'Eroare',
              message: 'A aparut o problema - modificarile nu au fost salvate!',
              type: 'error',
            });
          }
        }
      });
    },


  },


  mounted() {
    if (!this.$has_right('Management')) {
      this.$router.push("/no-rights");
      return;
    }
    this.base_url = settings.BASE_URL;
    this.get_info();
  },
};
</script>

<style lang="less" scoped>
.main-page {
  width: 100%;
  display: flex;
  justify-content: space-evenly;
  align-items: flex-start;
}

.commands {
  font-size: 14px;
  opacity: 0.3;
}

.commands-btn-area {
  width: 100%;
  height: auto;
  display: flex;
  justify-content: space-evenly;
  flex-wrap: wrap;

  .el-button {
    margin: 5px 0;
    width: 40%;
    font-size: 14px;
  }
}

.top50 {
  margin-top: 20px;
}

.filtre {
  .el-input-number {
    width: 100% !important;
  }
}

.input-element {
  width: 50%;
}

@media only screen and (max-width: 600px) {
  .input-element {
    width: 80%;
  }

  .main-page {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;

    .coloana {
      width: 95%;
    }
  }

  .el-tooltip__popper {
    width: 90%;
  }
}
</style>
